import React, { useState } from 'react';
import { Drawer, Form, Input, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import './index.scss';
import { baseURL } from '@/util/network/axios';
import { selectSchoolId } from '../../../../../../store/reducers/schoolInfo';
import { useSelector } from 'react-redux';
import { preview, uploadparams } from '@/util/public';

const { TextArea } = Input;

const ReportDrawer = ({ visible, onClose, onSubmit }) => {
    const schoolId = useSelector(selectSchoolId);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  // 提交表单
  const handleOk = () => {
    form.validateFields()
      .then(values => {
        onSubmit?.({
          ...values,
          resIds: fileList.map(item=>item?.response?.data?.resId),
        });
        form.resetFields();
        setFileList([]);
        onClose?.();
      })
      .catch(info => {
        console.log('校验失败:', info);
      });
  };

  // 上传文件变化
  const handleChange = (info) => {
    setFileList(info.fileList);
  };

  // 支持的文件类型
  const acceptTypes = [
    '.doc', '.docx', '.pdf',
    '.jpg', '.jpeg', '.png',
    '.xls', '.xlsx', '.zip'
  ].join(',');

  return (
    <Drawer
      title="报名信息有误申报"
      placement="right"
      onClose={onClose}
      open={visible}
      width={630}
      getContainer={false}
      rootClassName='report-drawer'
      footer={
        <div className="drawer-footer">
            <Button type="primary" onClick={handleOk}>确定</Button>
            <Button onClick={onClose}>取消</Button>
          
        </div>
      }
    >
      <Form
        form={form}
        layout="horizontal"
        className="report-form"
      >
        <Form.Item
          label="联系电话"
          name="contactPhone"
          rules={[
            { required: true, message: '请输入联系电话' },
            { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' }
          ]}
        >
          <Input placeholder="请输入联系电话" />
        </Form.Item>

        <Form.Item
          label="内容描述"
          name="errorDescription"
          rules={[{ required: true, message: '请输入内容描述' }]}
        >
          <TextArea
            rows={8}
            placeholder="请详细描述报名信息有误的情况"
            style={{
                resize: "none"
            }}
          />
        </Form.Item>

        <Form.Item label="证明材料" style={{marginLeft: 11}}>
          <Upload
            accept={acceptTypes}
            fileList={fileList}
            onChange={handleChange}
            action={baseURL + "/common/uploadFile"}
            headers={{ schoolid: schoolId }}
            data={(file) => uploadparams(file, "image_file")}
            multiple={false}
            maxCount={8}
            listType="text"
            beforeUpload={(file: any, fileList?: any) => {
                let type1 = file.name.split('.');
                let type = type1[type1.length - 1];
                const ismatch =
                    acceptTypes.indexOf(
                    type.toLowerCase()
                    ) !== -1;
                if (!ismatch) {
                    message.error('上传文件不符合格式要求，请重新上传!');
                    return Upload.LIST_IGNORE;
                }
                const isLt2M = file.size / 1024 / 1024 < 20;
                if (!isLt2M) {
                    message.error('文件大小不能超过20M!');
                    return Upload.LIST_IGNORE;
                }
                return ismatch && isLt2M;
            }}
            itemRender={(originNode, file, currentFileList) => {
                return (
                    <div
                        className="upedlist"
                        style={{ cursor: "pointer", position: "relative" }}
                    >
                        <div
                            onClick={() => preview(file)}
                            style={{ position: "absolute", left: "0px", top: "0px", height: "100%", width: "calc(100% - 24px)" }}></div>
                        {originNode}
                    </div>
                )
            }}
          >
            <Button icon={<UploadOutlined />}>上传附件</Button>
          </Upload>
          <div className="upload-tip">
            （支持上传doc/docx/pdf/jpg/jpeg/png/xls/xlsx/zip格式的文件）
          </div>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default ReportDrawer;